import React from "react";
import { FormattedMessage } from "react-intl";
import { EuiLink } from "@elastic/eui";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        sortable: true,
        width: 70,
    },
    {
        field: "nameAr",
        name: <FormattedMessage id="branch.arabic-name" />,
        sortable: true,
    },
    {
        field: "nameEn",
        name: <FormattedMessage id="branch.english-name" />,
        sortable: true,
    },

    {
        field: "updatedAt",
        dataType: "date",
        name: <FormattedMessage id="branch.updated-at" />,
        sortable: true,
    },
    {
        field: "createdAt",
        dataType: "date",
        name: <FormattedMessage id="branch.created-at" />,
        sortable: true,
    },
    {
        field: "creatorId",
        name: <FormattedMessage id="branch.creator.id" />,
        sortable: false,
    },
    {
        field: "creatorEmail",
        name: <FormattedMessage id="branch.creator.email" />,
        sortable: false,
    },
    {
        field: "creatorType",
        name: <FormattedMessage id="branch.creator.type" />,
        sortable: false,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
